import * as React from "react";
import { Margin, P, Link, TextLink } from "@ovotech/element";
import { ReSendEmailConfirm } from "_pages/ConfirmEmail";

export const LinkExpiredPageContent = () => (
  <>
    <ReSendEmailConfirm />
    <P>
      Any questions, give us a call on{" "}
      <TextLink href="tel:03303035059">0330 303 5059</TextLink> or email us at{" "}
      <TextLink href="mailto:electricvehicles@ovoenergy.com">
        electricvehicles@ovoenergy.com
      </TextLink>
    </P>
    <Margin top={10} />
    <Link
      variant="outline"
      data-testid="navigate-button"
      href="https://www.ovoenergy.com/"
    >
      Return to the homepage
    </Link>
  </>
);
